import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "wrapper" };
const _hoisted_2 = {
    key: 0,
    class: "cy-cal-value pb-3 body1-text text-center"
};
const _hoisted_3 = { class: "text-right d-flex justify-space-between" };
import { computed, toRefs, } from 'vue';
import { format } from 'date-fns';
import dateFormatType from '@/constants/dateFormatType';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    props: {
        internalModelValue: { default: () => [] },
        joinFormat: { default: ' ~ ' },
        displayFormat: { default: dateFormatType.DATE },
        hideDate: { type: Boolean, default: false },
        closeBtnOnly: { type: Boolean, default: false },
        selectDate: { type: Function, default: () => { } },
        closePicker: { type: Function, default: () => { } }
    },
    setup(__props) {
        const props = __props;
        const { internalModelValue, joinFormat, displayFormat, selectDate, closePicker, } = toRefs(props);
        const parseDate = computed(() => {
            let tmp = internalModelValue.value === null
                ? new Date()
                : internalModelValue.value;
            if (!Array.isArray(tmp)) {
                tmp = [
                    tmp,
                ];
            }
            return tmp
                .map((it) => format(it, displayFormat.value))
                .join(joinFormat.value);
        });
        const handleClickNo = () => {
            closePicker.value();
        };
        const handleClickOk = () => {
            selectDate.value();
        };
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!_ctx.hideDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(parseDate.value), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_3, [
                    (_ctx.closeBtnOnly)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "brg-btn size-xxs info outlined",
                            onClick: handleClickNo
                        }, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                _createTextVNode(" 닫기 ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [0]
                        }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_v_btn, {
                                class: "cy-cal-cancel brg-btn size-xxs info outlined",
                                onClick: handleClickNo
                            }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createTextVNode(" 취소 ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [1]
                            }),
                            _createVNode(_component_v_btn, {
                                class: "cy-cal-ok brg-btn size-xxs primary",
                                onClick: handleClickOk
                            }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createTextVNode(" 확인 ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [2]
                            })
                        ], 64 /* STABLE_FRAGMENT */))
                ])
            ]));
        };
    }
});
